/**
 * Neutral interstitial shown while the admin gate (GET /api/admin/me) resolves.
 * Renders NO admin chrome and NO feature data — the guard renders this instead
 * of children while the answer is unknown (fail-closed: unknown ≠ admin).
 */
import { Skeleton } from '@andavo/web-ui';

export function AdminChecking() {
  return (
    <div
      aria-busy="true"
      className="flex h-full w-full flex-col items-center justify-center gap-3 p-6"
      data-testid="admin-checking"
    >
      <Skeleton className="h-6 w-40" />
      <p className="font-inter text-content-secondary text-sm">
        Checking admin access…
      </p>
    </div>
  );
}
